import { render, staticRenderFns } from "./HostTest.vue?vue&type=template&id=6310e3f5&scoped=true&"
import script from "./HostTest.vue?vue&type=script&lang=js&"
export * from "./HostTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6310e3f5",
  null
  
)

export default component.exports